function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Canvas",
  transform: "translate(-4165 -1416)"
}, /*#__PURE__*/React.createElement("g", {
  id: "pause1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path 172"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pause2_path0_fill",
  transform: "translate(4174.35 1416.32)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path 173"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pause2_path1_fill",
  transform: "translate(4165 1416.32)"
}))));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "pause2_path0_fill",
  d: "M 6.10352e-06 21.369L 5.34601 21.369L 5.34601 0L 6.10352e-06 0L 6.10352e-06 21.369ZM 1.339 1.331L 4.008 1.331L 4.008 20.031L 1.339 20.031L 1.339 1.331Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "pause2_path1_fill",
  d: "M 6.10352e-06 21.369L 5.346 21.369L 5.346 0L 6.10352e-06 0L 6.10352e-06 21.369ZM 1.338 1.331L 4.00699 1.331L 4.00699 20.031L 1.338 20.031L 1.338 1.331Z"
}));

function SvgPause2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "-12 -9 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause2);
export default __webpack_public_path__ + "static/media/pause2.04661776.svg";
export { ForwardRef as ReactComponent };